// Week 33 Speaking Mindmap (36 Branches: 6 Stems x 6 Labels)
export default {
  centerStems: [
    {
      id: 1,
      label: "Corridor Safety Rules",
      branches: [
        { id: "1_1", label: "Walk carefully after class" },
        { id: "1_2", label: "Never run on wet tiles" },
        { id: "1_3", label: "Look out for warning signs" },
        { id: "1_4", label: "Keep school bags off floor" },
        { id: "1_5", label: "Walk carefully on the stairs" },
        { id: "1_6", label: "Report wet puddles to janitor" }
      ]
    },
    {
      id: 2,
      label: "First Aid Care",
      branches: [
        { id: "2_1", label: "Call school nurse right away" },
        { id: "2_2", label: "Apply clean white bandage" },
        { id: "2_3", label: "Use cold pack for swelling" },
        { id: "2_4", label: "Keep injured classmate calm" },
        { id: "2_5", label: "Do not move broken leg" },
        { id: "2_6", label: "Wash small cuts with water" }
      ]
    },
    {
      id: 3,
      label: "Accident Prevention",
      branches: [
        { id: "3_1", label: "Clean up spilled water fast" },
        { id: "3_2", label: "Tie shoe laces tightly" },
        { id: "3_3", label: "Wear safe rubber shoes" },
        { id: "3_4", label: "Walk in single line" },
        { id: "3_5", label: "Avoid pushing near doors" },
        { id: "3_6", label: "Keep hallways bright and clear" }
      ]
    },
    {
      id: 4,
      label: "School Responsibilities",
      branches: [
        { id: "4_1", label: "Follow teacher instructions" },
        { id: "4_2", label: "Help injured friends quickly" },
        { id: "4_3", label: "Say sorry for clumsy mistakes" },
        { id: "4_4", label: "Remind classmates about rules" },
        { id: "4_5", label: "Respect janitors and staff" },
        { id: "4_6", label: "Praise responsible actions" }
      ]
    },
    {
      id: 5,
      label: "Helping Friends",
      branches: [
        { id: "5_1", label: "Stay beside hurt friend" },
        { id: "5_2", label: "Speak gently to calm them" },
        { id: "5_3", label: "Carry their heavy schoolbag" },
        { id: "5_4", label: "Inform teacher immediately" },
        { id: "5_5", label: "Offer bottle of fresh water" },
        { id: "5_6", label: "Walk them to nurse office" }
      ]
    },
    {
      id: 6,
      label: "Emergency Action",
      branches: [
        { id: "6_1", label: "Stay calm and do not panic" },
        { id: "6_2", label: "Shout for adult help" },
        { id: "6_3", label: "Clear space around person" },
        { id: "6_4", label: "Press cold pack gently" },
        { id: "6_5", label: "Explain accident clearly" },
        { id: "6_6", label: "Follow nurse medical advice" }
      ]
    }
  ]
};
